import { createSelector } from 'reselect';

import PREMIUM_CHANGE from '../../features/premium-change/constants';
import selectCartProductId from '../select-cart-product-id';

const getEnabledProduct = () =>
  //   Premium change for November 1 2022 will be run on all products
  PREMIUM_CHANGE.ENABLED;

// Being used as a selector due to unpredictability of products affected by premium review year to year
const selectIsPremiumChangeEnabled = createSelector(selectCartProductId, getEnabledProduct);

export default selectIsPremiumChangeEnabled;
